export const BALLS = ['ball_1', 'ball_2', 'ball_3', 'ball_4', 'ball_5'];
export const BANDS = [
  { name: 'T5', start: 1, end: 5, soft: 'bg-emerald-50', text: 'text-emerald-900' },
  { name: 'T10', start: 6, end: 10, soft: 'bg-sky-50', text: 'text-sky-900' },
  { name: 'T15', start: 11, end: 15, soft: 'bg-violet-50', text: 'text-violet-900' },
  { name: 'T20', start: 16, end: 20, soft: 'bg-amber-50', text: 'text-amber-900' },
];
export const STABILITY = { green: '🟢 stable', amber: '🟡 caution', gray: '⚪ noise', unavailable: '— awaiting results' };

// Round only for presentation; use counts to avoid double-rounding API decimals.
export const roundedHitPercent = metric => metric.pct == null || !metric.draws_considered
  ? null : Math.round(100 * metric.hits / metric.draws_considered);

export const comparisonVerdict = (metric) => {
  if (metric?.pct == null) return { label: 'Unavailable', color: 'bg-gray-100 text-gray-600' };
  if (metric.pct === 0) return { label: 'No hits yet', color: 'bg-gray-800 text-white' };
  const gap = Math.max(0, Math.round(100 / metric.pct) - 1);
  const streak = metric.miss_streak;
  if (streak === 0) return { label: `Fresh hit · Exp ${gap}`, color: 'bg-emerald-500 text-white' };
  if (streak < gap) return { label: `Within norm · Exp ${gap}`, color: 'bg-gray-200 text-gray-800' };
  if (streak === gap) return { label: `Due next · Exp ${gap}`, color: 'bg-amber-400 text-amber-900' };
  if (streak === gap + 1) return { label: `Overdue · Exp ${gap}`, color: 'bg-rose-500 text-white' };
  return { label: `Deep overdue +${streak - gap} · Exp ${gap}`, color: 'bg-rose-700 text-white' };
};

export const exportComparisons = async (windows, source) => {
  const XLSX = await import('xlsx');
  const rows = windows.flatMap(w => BALLS.flatMap((ball, bi) => BANDS.map(band => {
    const data = w.balls[ball];
    const metric = data.buckets[band.name];
    const numbers = source === 'current' ? data.current_top20 : data.historical_top20;
    const row = { Window: `${w.window_id} ${w.window_name}`, Ball: bi + 1, Band: band.name,
      'P range': `P${band.start}–P${band.end}`, Hits: metric.hits, 'Draws considered': metric.draws_considered,
      'Success %': roundedHitPercent(metric) ?? 'Unavailable', Verdict: comparisonVerdict(metric).label,
      Stability: STABILITY[data.stability], 'Number display': source };
    for (let p = band.start; p <= band.end; p++) {
      const slot = data.per_p[String(p)];
      const prefix = `Slot ${p - band.start + 1}`;
      Object.assign(row, { [`${prefix} rank`]: `P${p}`, [`${prefix} number`]: numbers[p - 1] ?? '',
        [`${prefix} hits`]: slot.hits, [`${prefix} draws`]: slot.draws_considered, [`${prefix} %`]: roundedHitPercent(slot) ?? 'Unavailable' });
    }
    return row;
  })));
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(rows), 'BD1');
  XLSX.writeFile(workbook, `W50_BD1_${new Date().toISOString().slice(0, 10)}.xlsx`);
};
